module.exports = __webpack_public_path__ + "img/img-5.75092903.webp";